<template>
    <div class="mb-5 md:max-w-4xl md:m-auto">
        <div v-bind:class="ifLoading" class="loader">
            <TheSpinner />
        </div>
        <div v-if="loading">
            <div>
                <div class="text-center relative">
                    <countdown :countdown="items[0].anstoss" v-if="items[0].sheduletype === 'vorschau'"></countdown>
                    <div class="inline-block matchvs">
                        <router-link v-bind:to="items[0].home_router">
                            <ergebnis v-if="items[0].sheduletype === 'ergebnis'">{{items[0].home_tore}}</ergebnis>
                            <teams>
                                <the-language :de="items[0].home_de" :en="items[0].home_en" />
                                <div class="flagsize">
                                    <img v-bind:src="items[0].home_land" />
                                </div>
                            </teams>
                        </router-link>
                    </div>
                    <div class="inline-block">
                        <router-link v-bind:to="items[0].away_router">
                            <ergebnis v-if="items[0].sheduletype === 'ergebnis'">{{items[0].away_tore}}</ergebnis>
                            <teams>
                                <the-language :de="items[0].away_de" :en="items[0].away_de" />
                                <div class="flagsize">
                                    <img v-bind:src="items[0].away_land">
                                </div>
                            </teams>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="px-5 text-center relative flexbox ergebnis">
                <div class="inline-block w-full p-5 border-t border-b border-primary-orange md:pl-4 leading-relaxed text-primary-red">
                    <router-link v-bind:to="items[0].sport_router">
                        <the-language :de="items[0].sportart_de" :en="items[0].sportart_en" /> &nbsp;
                        <the-language :de="items[0].alter_de" :en="items[0].alter_en" /><br />
                        <the-language :de="items[0].group_de" :en="items[0].group_en" />
                    </router-link>
                </div>

                <div class="inline-block w-full p-5 border-b border-primary-orange md:pl-4 leading-relaxed">
                    <the-language :de="items[0].date_de" :en="items[0].date_en" /><br />
                    <the-language :de="items[0].sportplatz_de" :en="items[0].sportplatz_en" />
                </div>



            </div>


        </div>
    </div>
</template>


<script>
    import TheTitle from "../TheTitle";
    import TheLanguage from "../TheLanguage";
    import TheSpinner from "../TheSpinner"
    import TheTextView from "../TheTextView";
    import ergebnis from "../match/ergebnis";
    import teams from "../match/teams"
    import countdown from "../countdown/matchcountdown";

    export default {
        name: 'match',
        components: {
            TheSpinner,
            TheLanguage,
            TheTitle,
            TheTextView,
            ergebnis,
            teams,
            countdown
        },
        data(){
            return{
                currentFilter: 'ALL',
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/match/'+this.$route.params.id+'.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .flagsize{
        margin-top: 5px;
        display: block;
        text-align: center;
        width: 100%;
        img{
            max-width: 40px;
            display: inline-block;
        }
    }
    .matchvs{
        &:before{
            content: '';
            width: 1px;
            @apply bg-primary-orange;
            display: block;
            height: 95%;
            top: 5%;
            position: absolute;
            right: -2.4rem;
        }
        margin-right: 5rem;
        position: relative;
        &:after{
            color: #368dc7;
            content: "vs";
            -webkit-text-fill-color: #368dc7;
            border: 2px solid #f8b234;
            background: #fff;
            border-radius: 100%;
            padding: 0;
            position: absolute;
            right: -4rem;
            width: 50px;
            height: 50px;
            font-size: 30px;
            line-height: 45px;
            top: 50%;
            font-weight: lighter;
            margin-top: -25px;
        }
    }
</style>
